export default __webpack_public_path__ + "static/media/consultas.6b8b4269.svg";